import api from './api';
import { cleanParams, normalizeListResponse } from './violations';

/**
 * API-слой поиска дублей (№21): задание анализа, кандидаты и сводка проверки.
 * baseURL axios-инстанса уже равен /api.
 */

export const startDuplicateAnalysis = (body) =>
  api.post('/duplicate-analysis/jobs', body).then((response) => response.data);

export const getDuplicateAnalysisJob = (jobId) =>
  api.get(`/duplicate-analysis/jobs/${encodeURIComponent(jobId)}`).then((response) => response.data);

export const cancelDuplicateAnalysis = (jobId) =>
  api.post(`/duplicate-analysis/jobs/${encodeURIComponent(jobId)}/cancel`).then((response) => response.data);

export const listDuplicateCandidates = (params = {}) =>
  api
    .get('/duplicate-candidates', { params: cleanParams(params) })
    .then((response) => normalizeListResponse(response.data, params.limit));

export const getDuplicateReviewSummary = (params = {}) =>
  api
    .get('/duplicate-candidates/review-summary', { params: cleanParams(params) })
    .then((response) => response.data);

/** state: 'confirmed_duplicate' | 'rejected_duplicate'. */
export const decideDuplicateCandidate = (candidateId, state) =>
  api.patch(`/duplicate-candidates/${candidateId}`, { state }).then((response) => response.data);

/** FE-CORR-07 DUP-001: можно ли сейчас создавать задания и смотреть сохранённые пары. */
export const getDuplicateCapabilities = () =>
  api.get('/duplicate-analysis/capabilities').then((response) => response.data);
